import { Col, Descriptions, QRCode, Row, Typography } from "antd";
import React from "react";
import "./InforItem.scss";
import DecodeCD from "helper/decodeCD";

const InfoItem = (props) => {
  const {
    fields1,
    fields2,
    fields3,
    idBenhNhan,
    title,
    chiefComplaints,
    isChiefComplant = true,
    isChanDoan = false,
    chanDoanValue,
    address,
    spanLeft = 14,
    spanRight = 10,
    h2 = false,
    qr = true,
    bold = "",
  } = props;
  return (
    <div className="infoItem">
      <Row justify={"center"}>
        {h2 ? (
          <h2
            style={{
              fontWeight: "700",
              margin: "0px 10px 10px 10px",
            }}
          >
            {title}
          </h2>
        ) : (
          <Typography.Title
            style={{
              fontWeight: "700",
              fontSize: "30px",
            }}
          >
            {title}
          </Typography.Title>
        )}
      </Row>
      <Row>
        <Col span={qr ? 21 : 24}>
          <Row>
            <Col span={spanLeft ?? qr ? spanLeft : 16}>
              <Descriptions
                size="small"
                column={{ xxl: 4, xl: 4, lg: 4, md: 4, sm: 4, xs: 4 }}
                className="custom-des"
              >
                {/* <Row wrap={true} style={{width: "100%"}}> */}
                {fields1 &&
                  fields1.map((e) => (
                    // <Col span={12}>
                    <Descriptions.Item label={e.label} span={4}>
                      {e?.value ?? "--"}
                    </Descriptions.Item>
                    // </Col>
                  ))}
                {/* </Row> */}
              </Descriptions>
            </Col>
            <Col span={spanRight ?? qr ? spanRight : 8}>
              <Descriptions
                size="small"
                className="custom-des"
                column={{ xxl: 4, xl: 4, lg: 4, md: 4, sm: 4, xs: 4 }}
              >
                {/* <Row wrap={true} style={{width: "100%"}}> */}
                {fields2 &&
                  fields2.map((e) => (
                    // <Col span={12}>
                    <Descriptions.Item label={e.label} span={e?.span ?? 4}>
                      <div
                        style={{
                          fontWeight:
                            e.label === "Mã bệnh nhân" ? bold ?? "" : "",
                        }}
                      >
                        {e?.value ?? "--"}
                      </div>
                    </Descriptions.Item>
                    // </Col>
                  ))}
                {/* </Row> */}
              </Descriptions>
            </Col>
            <Descriptions
              size="small"
              className="custom-des"
              column={{ xxl: 4, xl: 4, lg: 4, md: 4, sm: 4, xs: 4 }}
            >
              {/* <Row wrap={true} style={{width: "100%"}}> */}
              {fields3 &&
                fields3.map((e) => (
                  <Descriptions.Item label={e.label} span={e?.span ?? 4}>
                    {e?.value ?? "--"}
                  </Descriptions.Item>
                ))}
              {/* </Row> */}
            </Descriptions>
            {address && (
              <Col span={24}>
                <Descriptions className="custom-des">
                  <Descriptions.Item label={"Địa chỉ"}>
                    {address ?? "--"}
                  </Descriptions.Item>
                </Descriptions>
              </Col>
            )}
            {isChiefComplant && (
              <Col span={24}>
                <Descriptions className="custom-des">
                  <Descriptions.Item label={"Lý do khám"}>
                    {chiefComplaints ?? "--"}
                  </Descriptions.Item>
                </Descriptions>
              </Col>
            )}
            {isChanDoan && (
              <Col span={24}>
                <Descriptions className="custom-des">
                  <Descriptions.Item label={"Chẩn đoán"}>
                    <DecodeCD data={chanDoanValue} />
                  </Descriptions.Item>
                </Descriptions>
              </Col>
            )}
          </Row>
        </Col>
        {qr ? (
          <Col span={3}>
            <Row justify={"end"}>
              <QRCode value={idBenhNhan} size={100} />
            </Row>
          </Col>
        ) : (
          ""
        )}
      </Row>
    </div>
  );
};
export default InfoItem;
